/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBulkSelectDeselectDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBulkSelectDeselectDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RsuAwardFilterService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardFilterPublishRsuAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward-filter/publish-rsu-award-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardFilterBulkDeleteRSuAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward-filter/bulk-delete-rSUAward-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardFilterExportRsuAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward-filter/export-rsu-award-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
